(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.tagName !== 'FORM') return;
    if (!form.matches('form[action="/cart/add"]')) return;
    if (form.closest('product-form')) return;
    if (form.closest('cart-drawer')) return;

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var body = new FormData(form);
    // Ask Shopify to include rendered section HTML in the add-to-cart response
    // (same technique Sense's product-form.js uses)
    body.append('sections', SECTIONS);
    body.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      if (response.status) {
        // Cart error (e.g. out of stock) — fall back to cart page
        window.location.href = '/cart';
        return;
      }
      rhOpenCartDrawer(response);
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = label; }
      window.location.href = '/cart';
    });
  });

  function rhOpenCartDrawer(addResponse) {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) { window.location.href = '/cart'; return; }

    if (typeof drawerEl.renderContents === 'function') {
      // addResponse already contains .sections from the POST — same shape Sense uses
      drawerEl.renderContents(addResponse);
    } else {
      // Fallback for older builds
      if (addResponse.sections) {
        rhUpdateSection('CartDrawer', addResponse.sections['cart-drawer']);
        rhUpdateSection('cart-icon-bubble', addResponse.sections['cart-icon-bubble']);
      }
      if (typeof drawerEl.open === 'function') {
        drawerEl.open();
      } else {
        drawerEl.setAttribute('open', '');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.removeAttribute('hidden');
      }
    }
  }

  function rhUpdateSection(id, html) {
    if (!html) return;
    var el = document.getElementById(id);
    if (!el) return;
    var newEl = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
    if (newEl) el.innerHTML = newEl.innerHTML;
  }
})();
